import { render } from "./DashboardGrid.vue?vue&type=template&id=51245008&scoped=true"
import script from "./DashboardGrid.vue?vue&type=script&lang=js"
export * from "./DashboardGrid.vue?vue&type=script&lang=js"

import "./DashboardGrid.vue?vue&type=style&index=0&id=51245008&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51245008"]])

export default __exports__